import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderTemplateNewFlowDeleteModalTemplate({ facilityOrderTemplateNewFlowDeleteModalStore, t }) {
    const {
        item,
        deleteTemplate,
        modalParams,
        disabled,
        numberOfTemplates,
        isNewPatient
    } = facilityOrderTemplateNewFlowDeleteModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Are you sure you want to delete this template?</h3>
            </div>
            <div className="modal__body">
                <p className="type--sml type--color--opaque u-mar--bottom--med">
                    {isNewPatient && numberOfTemplates && numberOfTemplates == 1 ?
                        "You are about to delete the last template of a new patient, and therefore, the entire patient. This action cannot be undone. Please confirm your choice." :
                        "This action cannot be undone. Please confirm your choice."}
                </p>
                {!numberOfTemplates && 
                <div className="card--patient">
                    <table width="100%" className="table--preview">
                        <colgroup>
                            <col width={450} />
                            <col width={200} />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th colSpan="3">
                                    <div className="u-flex--space-between">
                                        <label>{item.subCategory.name}</label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.facilityOrderTemplateItems.map((item) => {
                                return (
                                    <tr key={item.id} >
                                        <td>
                                            {item.product && item.product.description}
                                        </td>
                                        <td>
                                            {item.product && item.product.itemId}
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            {item.templateQuantity}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>}
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--warning'
                    label={t('EDIT_FORM_LAYOUT.DELETE')}
                    onClick={() => deleteTemplate()}
                    disabled={disabled}
                    rotate
                    icon={
                        disabled
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

FacilityOrderTemplateNewFlowDeleteModalTemplate.propTypes = {
    facilityOrderTemplateNewFlowDeleteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateNewFlowDeleteModalTemplate);
